import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Menu = ({ user }) => {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);

    // Defensive check for the routes array
    const routes = ['dashboard', 'lease', 'property', 'tenant', 'rent', 'cheque'];

    return (
        <>
            <div className="md:hidden fixed top-0 left-0 w-full bg-white shadow-md z-20 p-4 flex justify-between items-center">
                <img src="/logo.png" alt="Logo" className="w-10" />
                <button onClick={() => setIsOpen(!isOpen)} className="text-2xl">☰</button>
            </div>
            <div
                className={`fixed top-0 left-0 h-full bg-black shadow-lg z-10 p-5 transition-transform duration-300 
                ${isOpen ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0 md:w-1/8 `}
                style={{ width: "210px" }}
            >
                <div className="mb-8 text-center">
                    <h2 className="text-lg font-semibold">{user.username}</h2>
                </div>
                <ul className="space-y-4">
                    {routes.map((route) => {
                        if (route && typeof route === 'string') {
                            return (
                                <li
                                    key={route}
                                    onClick={() => { navigate(`/${route}`); setIsOpen(false); }}
                                    className="p-4 text-white cursor-pointer hover:bg-gray-200 rounded-md transition-colors"
                                >
                                    {route.charAt(0).toUpperCase() + route.slice(1)}
                                </li>
                            );
                        }
                        return null; // Handle the case if the route is invalid (undefined or null)
                    })}
                </ul>
            </div>
        </>
    );
};

export default Menu;
